import { Component } from '@angular/core';

@Component({
  selector: 'smart-fix-app-loading-dots',
  templateUrl: './chat-loading.html',
  styleUrls: ['./chat-loading.scss'],
})
export class LoadingDotsComponent {}
